import useSWR from 'swr'
import { GetSessionID } from '../Utility/SessionUtility';

/**
 * 地域マスタの型
 */
export interface RegionDataType {
    id: number,
    region_id: number,
    region_name: string,
    target_year: string
}

/**
 * 地域マスタHook
 */
export function useRegionMaster() {

    const fetchAddress = `/competition/api/management/tmc030/find?sessionId=${GetSessionID()}`;

    const fetcher = () => fetch(fetchAddress)
    .then(res => {
        return res.json();
    })
    .then(data => {
        return data?.region_data;
    });

    const {data, error, isLoading, mutate} = useSWR(`RegionMaster`, fetcher, {revalidateOnFocus:false, revalidateOnReconnect:false});

    return{
        /**
         * 地域マスタ配列
         */
        regionMaster: data,
        
        /**
         * ロード中フラグ
         */
        isLoading,

        /**
         * エラーフラグ
         */
        isError: error,

        /**
         * 再取得関数
         */
        mutate,
    }
}